import {
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  styled,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";

const DescGrid = styled(Grid)(({ theme }) => ({
  padding: "1%",
}));

const TitleGrid = styled(Grid)(({ theme }) => ({
  paddingLeft: "10%",
}));

type Props = {
  title: string;
  value: any;
  handleEdit: (e: any) => void;
};

export default function InputRadio({ title, value, handleEdit }: Props) {
  return (
    <Grid container justifyContent="center">
      <DescGrid container justifyContent="center">
        <TitleGrid item xs={12}>
          <Typography variant="h6" color="black">
            {title}
          </Typography>
        </TitleGrid>
        <TitleGrid container justifyContent="flex-start" item xs={12}>
          <FormControl>
            <RadioGroup
              aria-labelledby="demo-controlled-radio-buttons-group"
              name="controlled-radio-buttons-group"
              value={value.toString()}
              onChange={(e) => handleEdit(e.target.value === "true")}
              row
            >
              <FormControlLabel
                value="true"
                control={<Radio />}
                label={<Typography color="black">Ya</Typography>}
              />
              <FormControlLabel
                value="false"
                control={<Radio />}
                label={<Typography color="black">Tidak</Typography>}
              />
            </RadioGroup>
          </FormControl>
        </TitleGrid>
      </DescGrid>
    </Grid>
  );
}
